import useHoverEffect from 'frontend/utils/hooks/useHoverEffect'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
  className?: string
  hoverEffectCss?: string
}

const HoverEffect = ({ children, className, hoverEffectCss }: Props) => {
  const wrapperRef = useHoverEffect(hoverEffectCss)
  return (
    <div className={className} ref={wrapperRef}>
      {children}
    </div>
  )
}

export default HoverEffect
